<template>
    <Head title="Anmelden" />

    <div class="mx-auto max-w-6xl">
        <div class="px-4 sm:px-10 sm:text-center max-w-6xl md:mx-auto lg:text-left">
            <div>
                <Teaser :headlines="translate('teaser:headlines')" :small="true" :subline="translate('teaser:subline')"></Teaser>
            </div>
            <div class="mt-4 flex flex-shrink-0 md:mt-0 mb-6">
                <button type="button" class="mt-2 inline-flex items-center border border-transparent bg-indigo-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-800">Z</button>
            </div>
        </div>
    </div>
    <div class="px-4 sm:px-6 lg:px-8">
        <!-- Billing history -->
        <section aria-labelledby="billing-history-heading">
            <div class="bg-white pt-6 shadow sm:overflow-hidden sm:rounded-md">
                <div class="px-4 sm:px-6">
                    <h2 id="billing-history-heading" class="text-lg font-medium leading-6 text-gray-900">Billing history</h2>
                </div>
                <div class="mt-6 flex flex-col">
                    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                            <div class="overflow-hidden border-t border-gray-200">
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead class="bg-gray-50">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Date</th>
                                        <th scope="col" class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Description</th>
                                        <th scope="col" class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Amount</th>
                                        <!--
                                          `relative` is added here due to a weird bug in Safari that causes `sr-only` headings to introduce overflow on the body on mobile.
                                        -->
                                        <th scope="col" class="relative px-6 py-3 text-left text-sm font-medium text-gray-500">
                                            <span class="sr-only">View receipt</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody class="divide-y divide-gray-200 bg-white">
                                    <tr v-for="payment in payments" :key="payment.id">
                                        <td class="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                                            <time :datetime="payment.datetime">{{ payment.date }}</time>
                                        </td>
                                        <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">{{ payment.description }}</td>
                                        <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">{{ payment.amount }}</td>
                                        <td class="whitespace-nowrap px-6 py-4 text-right text-sm font-medium">
                                            <a :href="payment.href" class="text-orange-600 hover:text-orange-900">View receipt</a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

</template>

<script>
import {Head, usePage} from '@inertiajs/inertia-vue3'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'
import Teaser from "../../Components/Common/Teaser";
import translate from "../../../lang";
import { ref } from 'vue'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { Link } from '@inertiajs/inertia-vue3'
import { EnvelopeIcon, PhoneIcon } from '@heroicons/vue/20/solid'
import {
    FireIcon,
    CloudArrowUpIcon,
    PaperAirplaneIcon,
    ArchiveBoxIcon,
    ArrowRightCircleIcon,
    ChevronDownIcon,
    DocumentDuplicateIcon,
    HeartIcon,
    PencilIcon,
    TrashIcon,
    UserPlusIcon,
    ShareIcon,
    DocumentMagnifyingGlassIcon,
    ArrowUpRightIcon
} from '@heroicons/vue/20/solid'
import {
    ArrowPathIcon,
    ClockIcon,
} from '@heroicons/vue/24/outline';

import {Inertia} from "@inertiajs/inertia";
import Burn from './Dialogs/Burn';
import Transfer from './Dialogs/Transfer';
import Recreate from './Dialogs/Recreate';
import DeleteUnfinished from "./Dialogs/DeleteUnfinished";
import MetaData from "./Dialogs/MetaData";
import DeleteBurned from "./Dialogs/DeleteBurned";

export default {
    components: {
        CloudArrowUpIcon,
        Teaser,
        Link,
        Head,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        ArchiveBoxIcon,
        ArrowRightCircleIcon,
        ChevronDownIcon,
        DocumentDuplicateIcon,
        HeartIcon,
        PencilIcon,
        TrashIcon,
        UserPlusIcon,
        PaperAirplaneIcon,
        DocumentMagnifyingGlassIcon,
        ArrowUpRightIcon,
        FireIcon,
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        ExclamationTriangleIcon,
        ShareIcon,
        ArrowPathIcon,
        ClockIcon
    },
    props: {
        nfts: Array
    },
    setup(props) {
        let returnOptions = {
            translate: translate('dashboard.list'),
            translateAll: translate(),
        };
        return returnOptions;
    }
}
</script>
